import SectionReveal from './SectionReveal';

const steps = [
  {
    image: '/images/principle-analysis.jpg',
  },
  {
    image: '/images/principle-design.jpg',
  },
  {
    image: '/images/principle-technology.jpg',
  },
  {
    image: '/images/principle-realization.jpg',
  },
  {
    image: '/images/principle-service.jpg',
  },
];

export default function PrincipleSection({ t }) {
  const localizedSteps = [
    {
      title: t?.principleStep1 || 'Վերլուծություն',
      image: steps[0].image,
    },
    {
      title: t?.principleStep2 || 'Նախագծում',
      image: steps[1].image,
    },
    {
      title: t?.principleStep3 || 'Տեխնոլոգիա',
      image: steps[2].image,
    },
    {
      title: t?.principleStep4 || 'Իրականացում',
      image: steps[3].image,
    },
    {
      title: t?.principleStep5 || 'Սպասարկում',
      image: steps[4].image,
    },
  ];

  return (
    <section id="principles" className="py-12 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">

        {/* =========================
            БЛОК 1
        ========================== */}

        <SectionReveal>
          <div
            className="
              border-l-2 md:border-l-4
              border-[#0FA4E8]
              bg-gray-50
              p-5 md:p-10
            "
          >
            <h2
              className="
                mb-4
                text-2xl md:text-4xl
                font-black
                uppercase
                text-[#0B3B6F]
              "
            >
              {t.principleTitle}
            </h2>

            <p
              className="
                max-w-3xl
                text-base md:text-lg
                leading-relaxed
                text-slate-600
              "
            >
             {t.principleText}
            </p>
          </div>
        </SectionReveal>


        {/* =========================
            БЛОК 2
        ========================== */}

        <SectionReveal delay={150}>
          <div
            className="
              mt-10
              border-l-2 md:border-l-4
              border-[#0B3B6F]
              bg-gray-50
              p-5 md:p-10
            "
          >

            <h3
              className="
                mb-8
                text-xl md:text-2xl
                font-black
                uppercase
                text-[#0B3B6F]
              "
            >
            {t.principleHeading}
            </h3>


            {/* =========================
                GRID
            ========================== */}

            <div
              className="
                grid
                grid-cols-1
                sm:grid-cols-2
                lg:grid-cols-5
                gap-4
              "
            >

              {localizedSteps.map((step, idx) => (

                <div
                  key={idx}
                  className="
                    group
                    relative
                  "
                >

                  {/* CARD */}

                  <div
                    className="
                      relative
                      h-[180px]
                      md:h-[210px]

                      overflow-hidden
                      rounded-[24px]

                      border
                      border-gray-100

                      bg-white

                      shadow-sm

                      transition-all
                      duration-500

                      hover:-translate-y-1
                      hover:shadow-lg
                    "
                    style={{
                      backgroundImage: `
                        linear-gradient(
                          90deg,
                          rgba(255,255,255,1) 0%,
                          rgba(255,255,255,0.98) 25%,
                          rgba(255,255,255,0.88) 40%,
                          rgba(255,255,255,0.55) 60%,
                          rgba(255,255,255,0.15) 80%,
                          rgba(255,255,255,0) 100%
                        ),
                        url("${step.image}")
                      `,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  >

                    {/* Небольшой overlay */}

                    <div
                      className="
                        absolute
                        inset-0
                        bg-white/0
                        transition-all
                        duration-500
                        group-hover:bg-white/[0.04]
                      "
                    />


                    {/* CONTENT */}

                    <div
                      className="
                        relative
                        z-10

                        flex
                        h-full
                        flex-col
                        justify-between

                        p-5 md:p-6
                      "
                    >

                      {/* NUMBER */}

                      <span
                        className="
                          text-5xl
                          md:text-6xl

                          font-black
                          leading-none

                          text-gray-200

                          transition-all
                          duration-300

                          group-hover:text-[#0FA4E8]/20
                        "
                      >
                        {String(idx + 1).padStart(2, '0')}
                      </span>


                      {/* TITLE */}

                      <p
                        className="
                          max-w-[150px]

                          text-base
                          md:text-lg

                          font-black
                          leading-tight

                          text-[#0B3B6F]

                          transition-colors
                          duration-300

                          group-hover:text-[#0FA4E8]
                        "
                      >
                        {step.title}
                      </p>

                    </div>

                  </div>


                  {/* ARROW */}

                  {idx < localizedSteps.length - 1 && (
                    <div
                      className="
                        hidden
                        lg:flex

                        absolute
                        top-1/2
                        -right-3

                        z-20

                        h-6
                        w-6

                        -translate-y-1/2

                        items-center
                        justify-center

                        rounded-full

                        bg-white

                        shadow-sm
                      "
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#0FA4E8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14" />
                        <path d="m13 6 6 6-6 6" />
                      </svg>
                    </div>
                  )}

                </div>

              ))}

            </div>

          </div>
        </SectionReveal>

      </div>
    </section>
  );
}